import { domainEvent } from "@lookiero/messaging";
const NOTIFICATION_REMOVED = "notification_removed";
const notificationRemoved = ({ aggregateId }) => domainEvent({ aggregateId, name: NOTIFICATION_REMOVED });
const isNotificationRemoved = (event) => event.name === NOTIFICATION_REMOVED;
export { NOTIFICATION_REMOVED, notificationRemoved, isNotificationRemoved };
